import { render } from "./PicPhonePrivacyPolicy.vue?vue&type=template&id=56c5e2a0&scoped=true"
import script from "./PicPhonePrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PicPhonePrivacyPolicy.vue?vue&type=script&lang=js"

import "./PicPhonePrivacyPolicy.vue?vue&type=style&index=0&id=56c5e2a0&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c5e2a0"]])

export default __exports__